const distributorPayments = {
  'Review the purchase amount before authorizing payment. Bank units require confirmed funding.':
    'Revise el importe de la compra antes de autorizar el pago. Las unidades requieren fondos confirmados.',
  'Submit ACH payment': 'Enviar pago ACH',
  'Submit card payment': 'Enviar pago con tarjeta',
};

export default distributorPayments;
